import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'dynamicfilter'
  })
  export class dynamicPipe implements PipeTransform {
    transform(items: any[], searchText: string) {
        return items ? items.filter(item => item.helpDescription.search(new RegExp(searchText, 'i')) > -1) : [];
        }

  }